import { HOLIDAYS_ACTION_TYPE } from "../../actions/utilities";

const initialState = {
    getAll: [],
    getAllLoading: false,

    getById: null,
    getBYIdLoading: false,

    addLoading: false,

    removeLoading: false,

    editLoading: false
};

const holidayReducer = (state = initialState, action) => {
    switch (action.type) {
        case HOLIDAYS_ACTION_TYPE.CREATE_REQUEST:
            return {
                ...state,
                addLoading: true
            }
        case HOLIDAYS_ACTION_TYPE.CREATE_FAILURE:
        case HOLIDAYS_ACTION_TYPE.CREATE_SUCCESS:
            return {
                ...state,
                addLoading: false
            }

        case HOLIDAYS_ACTION_TYPE.UPDATE_REQUEST:
            return {
                ...state,
                editLoading: true
            }
        case HOLIDAYS_ACTION_TYPE.UPDATE_FAILURE:
        case HOLIDAYS_ACTION_TYPE.UPDATE_SUCCESS:
            return {
                ...state,
                editLoading: false
            }
        case HOLIDAYS_ACTION_TYPE.GET_REQUEST:
            return {
                ...state,
                getAllLoading: true
            }
        case HOLIDAYS_ACTION_TYPE.GET_FAILURE:
            return {
                ...state,
                getAllLoading: false
            }
        case HOLIDAYS_ACTION_TYPE.GET_SUCCESS:
            return {
                ...state,
                getAllLoading: false,
                getAll: action.payload
            }
        case HOLIDAYS_ACTION_TYPE.GET_BY_ID_REQUEST:
            return {
                ...state,
                getBYIdLoading: true
            }
        case HOLIDAYS_ACTION_TYPE.GET_BY_ID_FAILURE:
            return {
                ...state,
                getBYIdLoading: false
            }
        case HOLIDAYS_ACTION_TYPE.GET_BY_ID_SUCCESS:
            return {
                ...state,
                getBYIdLoading: false,
                getById: action.payload
            }
            case HOLIDAYS_ACTION_TYPE.REMOVE_REQUEST:
                return {
                    ...state,
                    removeLoading: true
                }
            case HOLIDAYS_ACTION_TYPE.REMOVE_FAILURE:
                return {
                    ...state,
                    removeLoading: false
                }
            case HOLIDAYS_ACTION_TYPE.REMOVE_SUCCESS:
                return {
                    ...state,
                    removeLoading: false,
                    getAll: {
                        ...state.getAll,
                        holidays: state.getAll.holidays.filter(
                          (holiday) => holiday.id !== action.payload
                        ),
                      },
                }
        default:
            return state;
    }
};

export default holidayReducer;
